/**
 * NotFoundPage Component
 * Premium 404 error page with gradient styling
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/common";
import { SearchX, ArrowLeft, Home } from "lucide-react";

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-navy-900 flex items-center justify-center p-4">
      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-[400px] h-[400px] bg-primary-500/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/4 right-1/4 w-[300px] h-[300px] bg-accent-500/10 rounded-full blur-[100px]" />
      </div>

      <div className="relative text-center max-w-md">
        {/* Icon */}
        <div className="w-24 h-24 rounded-full bg-gradient-to-br from-primary-500/20 to-accent-500/20 flex items-center justify-center mx-auto mb-6 border border-primary-500/30">
          <SearchX className="w-12 h-12 text-primary-400" />
        </div>

        {/* Title */}
        <h1 className="text-6xl font-bold bg-gradient-to-r from-primary-400 to-accent-400 bg-clip-text text-transparent mb-4">
          404
        </h1>
        <h2 className="text-2xl font-semibold text-white mb-2">Page Not Found</h2>
        <p className="text-slate-400 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            icon={<ArrowLeft className="w-4 h-4" />}
          >
            Go Back
          </Button>
          <Button
            variant="gradient"
            onClick={() => navigate("/")}
            icon={<Home className="w-4 h-4" />}
          >
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};